(function () {
  'use strict';

  var ATTR = 'data-preorder-release';
  var SELECTOR = '[' + ATTR + ']';
  var cachedKey = null;
  var cachedAt = 0;
  var scheduled = false;
  var pending = [];

  function computeAmsterdamDateKey() {
    try {
      var parts = new Intl.DateTimeFormat('en', {
        timeZone: 'Europe/Amsterdam',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      var values = {};
      parts.forEach(function (part) { values[part.type] = part.value; });
      return values.year + '-' + values.month + '-' + values.day;
    } catch (error) {
      var now = new Date();
      return now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
    }
  }

  function amsterdamDateKey() {
    var now = Date.now();
    if (!cachedKey || now - cachedAt >= 60000) {
      cachedKey = computeAmsterdamDateKey();
      cachedAt = now;
    }
    return cachedKey;
  }

  function isActive(releaseDate) {
    return /^\d{4}-\d{2}-\d{2}$/.test(releaseDate || '') && releaseDate > amsterdamDateKey();
  }

  function setText(element, value) {
    if (element && value != null && element.textContent !== value) element.textContent = value;
  }

  function setHidden(element, hidden) {
    if (element && element.hidden !== hidden) element.hidden = hidden;
  }

  function syncElement(element) {
    var active = isActive(element.getAttribute(ATTR));
    var role = element.getAttribute('data-preorder-role');
    var canAdd = element.getAttribute('data-preorder-can-add') !== 'false';

    if (role === 'notice') {
      setHidden(element, !active || !canAdd);
      return;
    }
    if (role === 'cart-badge') {
      setHidden(element, !active);
      return;
    }
    if (role === 'cart-warning') {
      setHidden(element, !active && element.getAttribute('data-preorder-undated') !== 'true');
      return;
    }
    if (role === 'cart-delivery') {
      var delayed = active || element.getAttribute('data-preorder-undated') === 'true' || element.getAttribute('data-lc-cart-stock-ready') !== 'true';
      setHidden(element.querySelector('[data-lc-cart-delivery-stock]'), delayed);
      setHidden(element.querySelector('[data-lc-cart-delivery-delayed]'), !delayed);
      return;
    }
    if (role === 'product-badge') {
      if (!active && !canAdd && element.getAttribute('data-preorder-show-soldout') === 'true') {
        setText(element, element.getAttribute('data-preorder-normal-label'));
        setHidden(element, false);
      } else {
        setHidden(element, !active);
      }
      return;
    }
    if (role === 'purchase-info') {
      var state = !canAdd ? 'unavailable' : active ? 'preorder' : element.getAttribute('data-preorder-backorder') === 'true' ? 'backorder' : 'stock';
      setText(element.querySelector('[data-lc-dispatch-title]'), element.getAttribute('data-lc-dispatch-' + state + '-title'));
      setText(element.querySelector('[data-lc-dispatch-copy]'), element.getAttribute('data-lc-dispatch-' + state + '-copy'));
      var pickupState = !canAdd ? 'unavailable' : state === 'preorder' || state === 'backorder' ? 'wait' : 'stock';
      setText(element.querySelector('[data-lc-pickup-copy]'), element.getAttribute('data-lc-pickup-' + pickupState + '-copy'));
      return;
    }
    if (role === 'shipping') {
      var message = element.querySelector('[data-preorder-shipping-message]');
      var copy = !canAdd ? 'data-preorder-soldout-copy' : active ? 'data-preorder-copy' : element.getAttribute('data-preorder-backorder') === 'true' ? 'data-preorder-backorder-copy' : 'data-preorder-stock-copy';
      setText(message, message && message.getAttribute(copy));
      setHidden(element.querySelector('[data-preorder-combined]'), !active || !canAdd);
      var pickup = element.querySelector('[data-preorder-pickup]');
      setHidden(pickup, !canAdd);
      setText(pickup, pickup && pickup.getAttribute(active ? 'data-preorder-pickup-pre-copy' : 'data-preorder-pickup-copy'));
      return;
    }
    if (role === 'line-property') {
      if (element.disabled !== !active) element.disabled = !active;
      return;
    }
    if (role === 'accelerated') {
      setHidden(element, active || !canAdd);
      return;
    }
    if (role === 'button') {
      var target = element.querySelector('[data-preorder-label-target]') || element.querySelector('.add-to-cart-text__content') || element.querySelector('.add-to-cart-text');
      var preorderLabel = element.getAttribute('data-preorder-label');
      var normalLabel = element.getAttribute('data-preorder-normal-label');
      if (!target || !preorderLabel || !normalLabel || element.classList.contains('loading')) return;
      var hadActiveLabel = element.getAttribute('data-preorder-active') === 'true';
      var productInfo = element.closest('product-info');
      var shipping = productInfo && productInfo.querySelector('[data-preorder-role="shipping"]');
      var backorder = shipping && shipping.getAttribute('data-preorder-backorder') === 'true';
      if (active && !element.disabled && !element.classList.contains('sold-out--button')) {
        setText(target, preorderLabel);
        if (!hadActiveLabel) element.setAttribute('data-preorder-active', 'true');
      } else {
        if (!active && hadActiveLabel && !backorder && !element.disabled && target.textContent.trim() === preorderLabel) setText(target, normalLabel);
        if (hadActiveLabel) element.removeAttribute('data-preorder-active');
      }
    }
  }

  function sync(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches(SELECTOR)) syncElement(scope);
    var list = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) syncElement(list[i]);
  }

  function flush() {
    scheduled = false;
    var items = pending;
    pending = [];
    if (items.indexOf(document) !== -1) {
      sync(document);
      return;
    }
    for (var i = 0; i < items.length; i++) {
      if (items[i].isConnected === false) continue;
      sync(items[i]);
    }
  }

  function queue(element) {
    if (pending.indexOf(element) === -1) pending.push(element);
    if (!scheduled) {
      scheduled = true;
      window.requestAnimationFrame(flush);
    }
  }

  function scheduleSync() {
    queue(document);
  }

  function onMutations(records) {
    for (var i = 0; i < records.length; i++) {
      var record = records[i];
      var target = record.target;
      if (record.type === 'attributes') {
        if (target && target.nodeType === 1) {
          if (record.attributeName === 'disabled' && target.matches('button[name="add"]')) syncPurchaseAvailability(target);
          if (target.hasAttribute(ATTR)) queue(target);
        }
        continue;
      }
      if (record.type !== 'childList') continue;
      var host = target && target.nodeType === 1 ? target.closest(SELECTOR) : null;
      if (host) {
        queue(host);
        continue;
      }
      for (var j = 0; j < record.addedNodes.length; j++) {
        var node = record.addedNodes[j];
        if (node.nodeType === 1 && (node.hasAttribute(ATTR) || node.querySelector(SELECTOR))) queue(node);
      }
    }
  }

  function syncPurchaseAvailability(button) {
    var productInfo = button.closest('product-info');
    if (!productInfo) return;
    var components = productInfo.querySelectorAll('[data-preorder-role="notice"], [data-preorder-role="shipping"], [data-preorder-role="purchase-info"], [data-preorder-role="accelerated"]');
    for (var i = 0; i < components.length; i++) {
      var value = button.disabled ? 'false' : 'true';
      if (components[i].getAttribute('data-preorder-can-add') !== value) components[i].setAttribute('data-preorder-can-add', value);
      queue(components[i]);
    }
  }

  function syncVariant(data) {
    if (!data || !data.html || !data.html.querySelectorAll) return;
    var sources = data.html.querySelectorAll('[data-preorder-product]');
    for (var i = 0; i < sources.length; i++) {
      var source = sources[i];
      var productId = source.getAttribute('data-preorder-product');
      var role = source.getAttribute('data-preorder-role');
      if (!/^\d+$/.test(productId || '') || (role !== 'notice' && role !== 'shipping' && role !== 'purchase-info')) continue;
      var targets = document.querySelectorAll('[data-preorder-product="' + productId + '"][data-preorder-role="' + role + '"]');
      for (var j = 0; j < targets.length; j++) {
        var target = targets[j];
        if (data.sectionId) {
          var productInfo = target.closest('product-info');
          if (productInfo && productInfo.dataset.section !== String(data.sectionId) && productInfo.dataset.originalSection !== String(data.sectionId)) continue;
        }
        var info = target.closest('product-info');
        var button = info && info.querySelector('product-form-component button[name="add"], product-form button[name="add"]');
        var canAdd = data.variant && data.variant.available && (!button || !button.disabled);
        target.setAttribute('data-preorder-can-add', canAdd ? 'true' : 'false');
        if (role === 'shipping') {
          target.setAttribute('data-preorder-backorder', source.getAttribute('data-preorder-backorder') || 'false');
        }
        queue(target);
      }
    }
  }

  function refresh() {
    cachedAt = 0;
    scheduleSync();
  }

  function start() {
    sync(document);
    var purchaseButtons = document.querySelectorAll('product-info product-form-component button[name="add"], product-info product-form button[name="add"]');
    for (var i = 0; i < purchaseButtons.length; i++) syncPurchaseAvailability(purchaseButtons[i]);
    new MutationObserver(onMutations).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'class', 'hidden', ATTR, 'data-preorder-can-add', 'data-preorder-backorder', 'data-preorder-undated']
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) { syncVariant(event.data); });
    }
    window.setInterval(function () {
      if (document.hidden || !document.querySelector(SELECTOR + ':not([' + ATTR + '=""])')) return;
      var previousKey = cachedKey;
      if (amsterdamDateKey() !== previousKey) scheduleSync();
    }, 60000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('submit', function (event) { cachedAt = 0; sync(event.target); }, true);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:section:reorder', scheduleSync);
  document.addEventListener('product:variant-change', scheduleSync);
  document.addEventListener('variant:change', scheduleSync);
})();
